import { GuardedDeletionService } from 'orchestrator';
import { Component, inject } from '@angular/core';
import { PropertyTypeGroupService } from '../proxy/planning/controllers';
import { ListService } from '@abp/ng.core';
import {
  CardComponent,
  CardBodyComponent,
  ConfirmationService,
} from '@abp/ng.theme.shared';
import {
  PropertyTypeGroupCreateDto,
  PropertyTypeGroupDto,
  PropertyTypeGroupExcelDownloadDto,
  PropertyTypeGroupUpdateDto,
} from '../proxy/planning/dtos/property-type-group';
import { PROPERTYTYPEGROUP_CONFIG, PROPERTYTYPEGROUP_FIELDS } from './property-type-group.config';
import { BaseCrudComponent, CrudPage, GenericForm } from '@zendra/shared';

@Component({
  selector: 'app-property-type-group',
  imports: [
    CardComponent,
    CardBodyComponent,
    CrudPage,
    GenericForm,
  ],
  providers: [ListService, PropertyTypeGroupService, ConfirmationService],
  templateUrl: './property-type-group.html',
  styleUrl: './property-type-group.scss',
})
export class PropertyTypeGroup extends BaseCrudComponent<
  PropertyTypeGroupDto,
  PropertyTypeGroupCreateDto,
  PropertyTypeGroupUpdateDto,
  PropertyTypeGroupExcelDownloadDto
> {
  private readonly guardedDeletion = inject(GuardedDeletionService);
  service = {
    ...inject(PropertyTypeGroupService),
    deleteByIds: (ids: number[]) => this.guardedDeletion.deleteByIds('PropertyTypeGroup', ids),
  };
  config = PROPERTYTYPEGROUP_CONFIG;
  fields = PROPERTYTYPEGROUP_FIELDS;

  protected prepareUpdateDto(data: any, selected: PropertyTypeGroupDto): PropertyTypeGroupUpdateDto {
    return {
      name: data.name,
      code: data.code,
      description: data.description,
      concurrencyStamp: selected.concurrencyStamp,
    };
  }

  protected getEntityName(): string {
    return 'PropertyTypeGroup';
  }
}
